<template>
    <div>
        <!--<button @click="test">ClickMe</button>-->
        <div class="overlay ModalOverlay" v-if="loading">
            <i class="fa fa-refresh fa-spin"></i>
        </div>
        <!--{{ allUsersSelected | json }}-->
        <dl v-for="(roleClub,role) in allClubsSelected">
            <dt>{{ role }}</dt>
            <dd v-for="club in roleClub">
                <div style="width:100%; display:inline-block">
                    <div class="selection-label">
                        <span class="selection-label_remove" role="presentation" @click="remove(club)">×</span>
                        {{ club.club.numero_club }} {{ club.club.club }}
                    </div>
                </div>
            </dd>
        </dl>
    </div>
</template>

<script type="text/babel">
    import {mapGetters, mapActions} from 'vuex'

    export default {
        computed: {
            //Map des getters de vuex
            ...mapGetters({
                allClubsSelected: 'getAllClubsSelected',
            }),
        },
        props: {
            clubs: {
                type: Array,
                default: function () {
                    return []
                },
                required: false
            },

            linkOnRemove: {
                type: String,
                required: false
            },
            idOther: Number,
            typeLink: String,
            sendAjax: {
                type: Boolean,
                default: true
            }
        },
        data() {
            return {
                msg: "",
                loading: false,
            }
        },
        methods: {
            ...mapActions({
                removeFromAllClubsSelected: "removeFromAllClubsSelected",
                addToAllClubsSelected: "addToAllClubsSelected"
            }),
            createPostData: function (club) {
                switch (this.typeLink.toLowerCase()) {
                    case 'compte':
//                        this.postData = {
//                            id_club: club.club.id,
//                            id_role: club.role.id,
//                            id_compte: this.idOther
//                        }
                        break;
                }
            },
            remove: function (club) {
                this.loading = true
                if (this.sendAjax) {
                    this.createPostData(club);
                    if (!this.$http)
                        return console.log('You need to install the `vue-resource` plugin')
                    if (!this.linkOnRemove)
                        return console.log('You need to set the linkOnRemove prop')

                    const linkOnRemove = this.linkOnRemove
                    this.$http.post(linkOnRemove, this.postData).then(function (response) {
                        let data = response.data
                        data = this.prepareResponseData ? this.prepareResponseData(data) : data
                        this.removeFromAllClubsSelected({role: club.role, user: club.membre})
                        this.loading = false
                        var n = noty({text: data, type: "success"});
                    }, (response) => {
                        this.loading = false
                        var n = noty({text: data, type: "error"});
                    })
                } else {
                    this.removeFromAllClubsSelected({role: club.role, club: club.club})
                    this.loading = false
                }
            },
            mounted: function () {
                this.$nextTick(function () {
                    if ((this.linkOnRemove == "" || typeof (this.linkOnRemove) == "undefined") && this.sendAjax)
                        this.linkOnRemove = routeRemoveClubToCompte;
                });

                this.$nextTick(function () {
                    if (this.clubs.length > 0) {
                        this.clubs = this.clubs[0]
                        for (var i = 0; i < this.clubs.length; i++) {
                            this.addToAllClubsSelected(this.clubs[i].role, this.clubs[i].club)
                        }
                    }
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Operations/listOfClubsLink.vue